import { IDropdownOption } from "@fluentui/react";

export const ActiveInactiveOptions = [
  { key: "true", text: "Ativo" },
  { key: "false", text: "Inativo" }
];

export const ENERGY_PROVIDER_OPTIONS: Array<IDropdownOption> = [
  { key: "CEMIG", text: "CEMIG" }
];
